// =============================================================================
// ERROR BOUNDARY - Обробка помилок React
// =============================================================================

import { Component, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="glass-card p-6 max-w-md text-center border-red-600/30">
            <span className="text-4xl mb-4 block">⚠️</span>
            <h2 className="text-xl font-bold text-red-500 mb-2">
              Технічна помилка
            </h2>
            <p className="text-slate-400 mb-4">
              Уточнюємо план дій... бо хтось знову все зробив “через дупу” Спробуйте оновити сторінку.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 rounded-lg transition-all glass-card"
            >
              <span className="bg-gradient-to-r from-blue-300 via-white to-amber-200 bg-clip-text text-transparent font-semibold">
                Оновити сторінку
              </span>
            </button>
            {this.state.error && (
              <p className="mt-4 text-xs text-slate-600 font-mono">
                {this.state.error.message}
              </p>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
